import FileCopyIcon from '@mui/icons-material/FileCopy';
import LaunchIcon from '@mui/icons-material/Launch';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import uniqueId from 'lodash/uniqueId';
import type React from 'react';
import { useMemo, useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

export type PreviewLinkMenuProps = {
  readonly url: string;
  readonly onCopy?: (text: string) => void;
};

const PreviewLinkMenu: React.FC<PreviewLinkMenuProps> = (props) => {
  const { url, onCopy } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const handleCopy = (text: string): void => {
    handleClose();
    if (onCopy) {
      onCopy(text);
    }
  };

  const id = useMemo(() => uniqueId('preview-link-menu-'), []);

  return (
    <div>
      <IconButton aria-controls={id} aria-haspopup="true" onClick={handleClick} size="large">
        <MoreVertIcon />
      </IconButton>
      <Menu id={id} anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem component="a" href={url} target="_blank" rel="noopener noreferrer" onClick={handleClose}>
          <ListItemIcon>
            <LaunchIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Open in new window" />
        </MenuItem>
        <CopyToClipboard text={url} onCopy={handleCopy}>
          <MenuItem>
            <ListItemIcon>
              <FileCopyIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Copy preview link" />
          </MenuItem>
        </CopyToClipboard>
      </Menu>
    </div>
  );
};

export default PreviewLinkMenu;
